import React from "react";

export function PageHeader({ title, description, actions, testId, kicker }) {
  return (
    <div data-testid={testId} className="mb-7 animate-in">
      {kicker && (
        <div className="label-cap mb-2 inline-flex items-center gap-2">
          <span className="inline-block w-3 h-[2px] rounded-full" style={{ background: "linear-gradient(90deg, var(--primary), transparent)" }} />
          {kicker}
        </div>
      )}
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-2xl sm:text-3xl lg:text-[2rem] font-semibold tracking-[-0.02em] ink leading-tight">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm muted max-w-3xl leading-relaxed">{description}</p>
          )}
        </div>
        {actions && <div className="flex gap-2 flex-wrap items-center shrink-0">{actions}</div>}
      </div>
    </div>
  );
}
